module.exports = __webpack_public_path__ + "img/card-small-b1.410f4d3f.png";